import React from "react";
import { RouteComponentProps } from "react-router";
import { useAppDispatch } from "store/hooks";
import { useSelector } from "react-redux";
import { push } from "connected-react-router";
import useNotificationActions from "modules/notification/hooks/useNotificationActions";
import { useI18n } from "i18n";
import { PageLoader } from "@remo-co/ui-core/src/components/PageLoader";
import { selectUser } from "modules/auth/redux/selectors";
import useAuth from "../auth/hooks/useAuth";
import useEventInviteActions from "./hooks/useEventInviteActions";

interface IBackdoorViewProps {
  eventCode?: string;
}

const BackdoorView = (
  props: IBackdoorViewProps & RouteComponentProps<{ eventCode: string }>,
) => {
  const user = useSelector(selectUser);
  const { isAuthenticated } = useAuth();
  const { addErrorNotification } = useNotificationActions();
  const { processJoinByCode } = useEventInviteActions();
  const { match } = props;
  const dispatch = useAppDispatch();
  const { t } = useI18n(["common", "server"]);

  const joinEventByCode = async () => {
    const joinResponse = await processJoinByCode(match.params.eventCode);

    if (joinResponse.isSuccess) {
      dispatch(push(`/ev/${joinResponse.code}`));
    } else {
      addErrorNotification({ message: t(joinResponse.message) });
    }
  };

  React.useEffect(() => {
    if (user) {
      joinEventByCode();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{isAuthenticated && <PageLoader message={t("loading.event")} />}</>;
};

export default BackdoorView;
